// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__U0vpB","title":"Images45_title__VTs8y","images":"Images45_images__2Ctht"};